import { combineReducers, configureStore } from "@reduxjs/toolkit";
import loginSlices from "./Slices/loginSlices";
import authSlice from "./Slices/authSlice"; 
import attendanceReducer from "./Slices/attendanceSlice";


// ─── 1. Redux Persist Imports ───
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; 

// ─── 2. Persist Config: only persist auth slice ───
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], 
};

// ─── 3. Combine Reducers ───
const rootReducer = combineReducers({
  LoginStatus: loginSlices,
  auth: authSlice,
  attendance: attendanceReducer,
});

// ─── 4. Wrap rootReducer with persistReducer ───
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ─── 5. Use persistedReducer in configureStore ───
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // These actions are from redux-persist and can safely be ignored
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// ─── 6. Export persistor object ───
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
